}<template>
  <div>
    <v-form ref="reservationForm">
      <!--活动相关信息-->
      <v-card class="ma-4 grey lighten-5">
        <v-card-text>
          <span style="font-size:16px;color:#757575">活动相关信息</span>
        </v-card-text>
        <v-divider></v-divider>
        <v-layout>
          <v-flex xs11 class="pl-4">
            <v-layout>
              <v-flex xs5 class="pl-3">
                <v-select
                  label="函件预约类型*"
                  :items=reservationForm.typeSelect
                  v-model="formData.letterApptType"
                  :rules="[$rules.requiredS('函件预约类型必填')]"
                  :disabled="disabledFlag||reservationType==='add'"></v-select>
              </v-flex>
              <v-flex xs6 class="pl-3">
                <v-text-field
                  label="函件活动名称*"
                  v-model="formData.letterApptName"
                  :rules="[$rules.requiredS('函件活动名称必填')]"
                  :disabled="disabledFlag||reservationType==='add'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs5 class="pl-3">
                <v-select
                  :items="reservationForm.host.orgSelect"
                  v-model="reservationForm.host.org"
                  item-value="value"
                  item-text="name"
                  label="受访人单位*"
                  :rules="[$rules.requiredS('必填')]"
                  :disabled="disabledFlag||reservationType==='add'"
                 ></v-select>
              </v-flex>
              <v-flex xs2 class="pl-3">
                <v-autocomplete
                  :disabled="reservationForm.host.org===''||disabledFlag||reservationType==='add'"
                  :items="reservationForm.host.hostSelect"
                  v-model="host"
                  v-on:keyup="hostSearch"
                  label="受访用户姓名*"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="loginId"
                  :rules="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该用户组用户信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs4 class="pl-3">
                <v-text-field
                  label="受访人手机"
                  disabled
                  v-model="reservationForm.host.hostPhone"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs5 class="pl-3">
                <v-text-field
                  label="申请人姓名"
                  v-model="reservationForm.appl.applName"
                  disabled></v-text-field>
              </v-flex>
              <v-flex xs6 class="pl-3">
                <v-text-field
                  label="申请人手机"
                  v-model="reservationForm.appl.applPhone"
                  disabled></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs11 class="pl-3">
                <v-textarea
                  label="函件活动描述"
                  v-model="formData.letterApptDesc"
                  rows="1"
                  auto-grow
                  counter="1000"
                  :disabled="disabledFlag||reservationType==='add'" ></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs3 class="pr-5 ml-0 pl-0">
            <!-- v-if="signFlag"-->
            <v-layout justify-center column v-if="signFlag">
              <v-layout justify-center>
                <h3 class="primary--text " style="text-align: center">预约车辆自助登记二维码</h3>
              </v-layout>
              <v-layout justify-center>
                <img :src="signUrl" style="width:200px;height:200px">
              </v-layout>
              <v-layout justify-center column>
                <v-btn color="primary" @click="getSelfSignFile" small>自助登记使用说明</v-btn>
                <v-btn color="primary" @click="getSelfSignList" small>自助登记车辆管理</v-btn>
                <v-btn slot="activator"
                       color="primary"
                       @click="getVisitorList"
                       small
                :disabled="formData.bulkImpVeList.length===0">
                  <span style="font-size: 14px">批量导入车辆管理</span>
                </v-btn>
              </v-layout>
              <!-- <img src="../../../assets/timg.jpg" style="width:100px;height: 100px"/>-->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
      <!--函件预约车辆管理-->
      <v-card class="ma-4 grey lighten-5">
        <v-card-text>
          <span style="font-size:16px;color:#757575">函件预约车辆管理</span>
          <span class="error--text">（二者必须选其一进行配置*）</span>
        </v-card-text>
        <v-divider></v-divider>
        <div>
          <v-radio-group row v-model="reservationForm.veSelect" class="pl-3">
            <v-radio label="预约车辆批量导入" value="veImport"></v-radio>
            <v-radio label="预约车辆自助登记" value="veSelfSign"></v-radio>
          </v-radio-group>
        </div>
        <v-divider></v-divider>
        <div v-show="reservationForm.veSelect==='veSelfSign'">
          <v-layout class="pl-3">
            <v-flex xs3>
              <v-text-field
                label="允许自助登记车辆最大值"
                v-model="formData.maxSelfReg"
                :rules="(reservationForm.veSelect==='veSelfSign')?[$rules.requiredS('输入不能为空'),$rules.requiredNum()]:[]"
                :disabled="disabledFlag"></v-text-field>
            </v-flex>
            <v-flex xs4>
              <l-select-datetime
                v-model="formData.qrcodeStaDtm"
                label="允许自助登记开始时间"
                :rules="(reservationForm.veSelect==='veSelfSign')?[$rules.requiredS('开始时间不能为空')]:[]"
                :disabled="disabledFlag"></l-select-datetime>
            </v-flex>
            <v-flex xs4>
              <l-select-datetime
                v-model="formData.qrcodeEndDtm"
                label="允许自助登记截止时间"
                :rules="(reservationForm.veSelect==='veSelfSign')?[$rules.requiredS('截止时间不能为空')]:[]"
                :disabled="disabledFlag"></l-select-datetime>
            </v-flex>
          </v-layout>
          <p class="pl-3 pt-2" style="font-size:16px;color:#757575">自助预约页面必填项</p>
          <v-layout class="pl-3">
            <v-flex xs2>
              <v-checkbox
                label="车辆号牌"
                v-model="formData.veSelfRegRule.veNum"
                disabled
              ></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                label="手机号码"
                v-model="formData.veSelfRegRule.phone"
                disabled
              ></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                label="车主姓名"
                v-model="formData.veSelfRegRule.name"
                :disabled="disabledFlag"
              ></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                label="车主单位"
                v-model="formData.veSelfRegRule.org"
                :disabled="disabledFlag"
              ></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                label="证件类型"
                v-model="formData.veSelfRegRule.idType"
                :disabled="disabledFlag"
              ></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                label="证件号码"
                v-model="formData.veSelfRegRule.id"
                :disabled="disabledFlag"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout class="pl-3">
            <v-flex xs4>
              <v-checkbox
                label="是否必须审核"
                v-model="formData.needReview"
                :disabled="disabledFlag"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </div>
        <div v-show="reservationForm.veSelect==='veImport'">
          <span class="ml-3" style="font-size:16px;color:#757575">函件预约车辆导入</span>
          <span style="font-size: 24px;" class="white--text">*</span>
          <span style="font-size: 16px">（2M以内）</span>
          <v-tooltip bottom class="ml-4">
            <v-btn slot="activator" @click="getExcelTemplate" color="primary" flat>
              <!--<v-icon color="primary">insert_drive_file</v-icon>-->
              <span style="font-size: 14px">下载车辆信息模板</span>
            </v-btn>
            <span>下载车辆信息模板</span>
          </v-tooltip>
          <l-select-file
            :dialog-props="vehicleFileProps"
            :hint="'仅支持Excel(.xlsx)文件'"
            :rules="vehicleFileRules"
            @cancel="vehicleFileProps.activate = false"
            @submit="readExcel"
            file-type="excel"
            select-type="dialog"
            v-if="newItem && auth.maxVehicleAmount > 1"
          >
            <v-btn class="mx-0" color="primary" flat :disabled="disabledFlag"
                   slot="activator">批量导入预约车辆
            </v-btn>
            <template slot="before-drag">
              <v-layout align-center class="mb-3 pl-2" row>
                <span class="body-2">批量添加车辆需要上传特定格式的模板</span>
              </v-layout>
            </template>
          </l-select-file>
          <v-tooltip bottom>
            <v-btn slot="activator"
                   flat
                   color="primary"
                   @click="getVisitorList"
                   :disabled="formData.bulkImpVeList.length===0">
              <span style="font-size: 14px">批量预约车辆管理</span>
            </v-btn>
            <span style="font-size: 14px">批量预约车辆管理</span>
            <!--<span v-else>未查询到保存的车辆信息</span>-->
          </v-tooltip>
        </div>
      </v-card>
      <!--添加车辆通行规则-->
      <v-layout class="ma-4" column v-if="reservationType==='add'">
        <v-switch
        v-model="reservationForm.passRuleSwitch"
        label="开启规则配置"></v-switch>
        <v-radio-group v-model="formData.passRuleType" row v-if="reservationForm.passRuleSwitch">
          <v-radio
            v-for="(n,i) in reservationForm.passRuleTypeSelect"
            :key="i"
            :label="n.name"
            :value="n.value"
          ></v-radio>
        </v-radio-group>
      </v-layout>
      <v-card class="ma-4 grey lighten-5" v-if="(reservationType==='common')||(reservationType==='add'&&reservationForm.passRuleSwitch===true)">
        <v-divider></v-divider>
        <v-card-text>
          <span class="" style="font-size:16px;color:#757575">添加车辆通行规则</span>
          <span style="font-size: 24px" class="error--text">*</span>
          <v-tooltip bottom class="ml-4">
            <v-btn
              slot="activator"
              icon
              :disabled="disabledFlag"
              @click="
                setRuleDialog={
                      activate: true,
                      status: 'new',
                      item: createPassRule(),
                      index: reservationForm.passRules.length
               }"
            >
              <v-icon color="primary">{{$vuetify.icons.add}}</v-icon>
            </v-btn>
            <span>添加车辆通行规则</span>
          </v-tooltip>
        </v-card-text>
        <l-pass-rule-list
          :pass-rules="formData.passRuleConf"
          prefix-text="时段"
        >
          <template slot="action" slot-scope="{item, index}">
            <div @click.stop>
              <v-menu v-if="newItem" left>
                <v-btn slot="activator" icon small>
                  <v-icon :color="'grey darken-3'" small>{{$vuetify.icons.more}}
                  </v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile
                    :disabled="disabledFlag"
                    @click="setRuleDialog={activate: true, status: 'edit',item: item, index: index}">
                    <v-list-tile-title class="pr-1">
                      <v-icon small class="pr-3">{{$vuetify.icons.edit}}</v-icon>
                      编辑
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    @click="deletePassRule(index)"
                    :disabled="disabledFlag">
                    <v-list-tile-title class="pr-1">
                      <v-icon small class="pr-3">{{$vuetify.icons.delete}}</v-icon>
                      删除
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </template>
        </l-pass-rule-list>
        <v-dialog scrollable persistent v-model="setRuleDialog.activate" max-width="900px">
          <set-pass-rule-content
            :authority="auth"
            v-if="setRuleDialog.activate"
            :status="setRuleDialog.status"
            :rule="setRuleDialog.item"
            :params="{index: setRuleDialog.index}"
            @cancel="setRuleDialog.activate=false"
            @save="setPassRule"
          ></set-pass-rule-content>
          <v-divider></v-divider>
        </v-dialog>
      </v-card>
      <!--函件预约签章文档-->
      <v-card class="ma-4 grey lighten-5">
        <v-card-text>
          <div>
            <span class="" style="font-size:16px;color:#757575">函件预约签章文档</span>
            <span style="font-size: 24px" class="error--text">*</span>
            <span style="font-size: 16px">（5M以内）</span>
            <v-tooltip bottom class="ml-4">
              <v-btn slot="activator" @click='exportPdf' color="primary"
                     flat :disabled="disabledFlag">
                <span style="font-size: 14px">导出函件预约申请</span>
              </v-btn>
              <span>导出函件预约申请</span>
            </v-tooltip>
            <l-select-file
              :dialog-props="pdfProps"
              :hint="'支持PDF(.pdf)文件、图片(.png、.jpg、.jpeg)文件'"
              @cancel="pdfProps.activate = false"
              @submit="uploadPdf"
              select-type="dialog"
            >
              <v-btn class="mx-0" color="primary" flat :disabled="disabledFlag" :loading="loading"
                     slot="activator">上传函件预约申请
              </v-btn>
            </l-select-file>
            <v-tooltip bottom>
              <v-btn slot="activator" color="primary" @click="downloadPdf" :disabled="!downloadFlag"
                     flat>
                <span style="font-size: 14px">下载签章预约申请</span>
              </v-btn>
              <span style="font-size: 14px">下载签章预约申请</span>
            </v-tooltip>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
    <v-layout justify-center v-show="config.status==='edit'">
      <v-btn class="warning" @click="saveReservation" :disabled="disabledFlag" :loading="loading">保存</v-btn>
      <v-btn class="success" @click="submitConfirm=true" :disabled="disabledFlag">提交</v-btn>
    </v-layout>
    <v-layout justify-center v-show="config.status==='review'">
      <v-btn class="error" @click="setReviewResult('refuse')" :disabled="reviewComplete">拒绝</v-btn>
      <v-btn class="warning" @click="setReviewResult('sendBack')" :disabled="reviewComplete">退回</v-btn>
      <v-btn class="success" @click="setReviewResult('pass')" :disabled="reviewComplete">通过</v-btn>
    </v-layout>
    <!--车辆信息导入Dialogz-->
    <v-dialog max-width="1000px" persistent scrollable v-model="importErrorDialog.activate">
      <v-card>
        <v-card-title style="height: 64px;">
          <span class="title">导入车辆发生错误</span>
        </v-card-title>
        <v-card-text style="min-height: 350px; max-height: 500px">
          <div class="mb-4" v-if="importErrorDialog.fails.length > 0">
            <div class="subheading py-2">以下车辆信息格式错误</div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :headers="vehicleHeaders"
              :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
              :items="importErrorDialog.fails"
              auto-actions
              flat
              hide-headers
              hide-title
            ></l-data-table>
          </div>
          <div class="mb-4" v-if="importErrorDialog.duplicates.length > 0">
            <div class="subheading py-2">以下车辆已在车辆列表中</div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :headers="vehicleHeaders"
              :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
              :items="importErrorDialog.duplicates"
              auto-actions
              flat
              hide-headers
              hide-title
            ></l-data-table>
          </div>
          <div v-if="importErrorDialog.vehicles.length > 0">
            <div class="py-2">
              <div class="subheading">以下车辆信息正确，等待导入</div>
              <div class="py-1" v-if="importErrorDialog.haveDuplicatePlate">
                <span class="error--text caption">您导入的模板中含有重复的车牌，导入时将以重复数据的第一条为准</span>
              </div>
            </div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :headers="vehicleHeaders"
              :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
              :items="importErrorDialog.vehicles"
              auto-actions
              flat
              hide-headers
              hide-title
            ></l-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="importVehicle(0)" color="grey" flat large>取消导入</v-btn>
          <v-btn :disabled="importErrorDialog.vehicles.length === 0" @click="importVehicle(importErrorDialog.vehicles)"
                 color="error" flat large>仍然导入
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="submitConfirm"
      width="500">
      <v-layout column>
        <v-card>
          <v-card-text>
            <span class="error--text">请确认填写信息后提交</span>
            <v-textarea
              v-model="reservationForm.comment"
              label="附言"
              counter="1000"
              :disabled="disabledFlag"
            >
            </v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn class="info" @click="submitReservation" :loading="loading">确定</v-btn>
              <v-btn class="warning" @click="saveComment" :disabled="disabledFlag">保存</v-btn>
              <v-btn class="error" @click="submitConfirm=false" :disabled="disabledFlag">取消</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
    <v-dialog
      v-model="reviewConfirm"
      width="500">
      <v-layout column>
        <v-card>
          <v-card-text>
            <span class="error--text">请确认后{{reservationForm.reviewMsg}}</span>
            <v-textarea
              v-model="reservationForm.comment"
              label="附言"
              counter="1000"
              :rules="(reservationForm.reviewResult==='pass')?[]:[$rules.requiredS('必填')]"
              :disabled="reviewComplete"
            >
            </v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn class="info" @click="completeReviewTask(reservationForm.reviewResult)" :loading="loading">确定</v-btn>
              <v-btn class="warning" @click="saveComment" :disabled="buttonDisabled">保存</v-btn>
              <v-btn class="error" @click="reviewConfirm=false" :disabled="buttonDisabled">取消</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import LSelectDatetime from '../../../ladmin/components/LSelectDatetime/LSelectDatetime'
import SetPassRuleContent from '../../../components/SetPassRuleContent'
import LPassRuleList from '../../../components/LPassRuleList'
import {PassRule} from '../../../object'
import {time, F} from '../../../ladmin/utils'
import XLSX from 'xlsx'

function Vehicle (id = 0, p = '', t = '', n = '', o = '', idt = '', idn = '') {
  return {
    id: id,
    plate: p,
    ownerTel: t,
    ownerName: n,
    ownerOrg: o,
    ownerIDNumber: idn,
    ownerIDType: idt
  }
}

function gateways2controllers (gateways) {
  let controllers = []
  if (gateways instanceof Array) {
    gateways.forEach(gateway => {
      gateway.controllers.forEach(c => {
        controllers.push(c.id)
      })
    })
  }
  return controllers
}

let IDTypeReverseMap = {
  '护照': 'passport',
  '军官证': 'osCard',
  '警官证': 'osCard',
  '士兵证': 'osCard',
  '港澳居民来往内地通行证': 'mtPermit',
  '台湾居民来往内地通行证': 'mtPermit',
  '居民身份证': 'idCard',
  '身份证': 'idCard',
  '港澳|台湾居民来往内地通行证': 'mtPermit',
  '军官证|警官证|士兵证': 'osCard',
  '学生证': 'stdCard'
}
let IDTypeMap = {
  'passport': '护照',
  'idCard': '居民身份证',
  'mtPermit': '港澳|台湾居民来往内地通行证',
  'osCard': '军官证|警官证|士兵证',
  'stdCard': '学生证'
}
let errorMap = {
  '1': '电话格式有误',
  '2': '车牌号码有误',
  '3': '证件类型或证件号码不全',
  '4': '证件号码错误'
}
export default {
  name: 'reservationDetailContent',
  components: {LSelectDatetime, SetPassRuleContent, LPassRuleList},
  props: {
    formData: {type: Object, default: () => ({})},
    config: {type: Object, default: () => ({})},
    reservationType: {type: String, default: 'common'}
  },
  data: () => ({
    /* 函件预约表单相关参数信息 */
    reservationForm: {
      /* 函件类型 */
      typeSelect: ['商业函件', '工作函件'],
      /* 受访人机构列表 */
      orgSelect: [],
      /* 函件预约车辆管理类型选择 */
      veSelect: 'veImport',
      /* 受访人信息 */
      host: {
        org: '',
        hostPhone: '',
        orgSelect: [],
        hostSelect: [],
        instId: ''
      },
      /* 申请人信息 */
      appl: {
        applName: '',
        applPhone: ''
      },
      /* 通行规则 */
      passRules: [],
      passRuleTypeSelect: [
        {name: '合并原预约规则', value: 'mergeRule'},
        {name: '创建新的预约规则', value: 'newRule'}
      ],
      passRuleSwitch: false,
      /* 表单key值 */
      formKey: '',
      formDefId: '',
      /* 上传文件定义相关信息 */
      fileKey: '',
      fileDefId: '',
      /* 任务附言 */
      comment: '',
      /* 审核结果相关信息 */
      reviewResult: '',
      reviewMsg: ''
    },
    host: '',
    /* 是否有可下载文件标记 */
    downloadFlag: false,
    /* 下载文件文件名 */
    downloadPdfName: '',
    /* 表单是否禁用标记 */
    disabledFlag: false,
    buttonDisabled: false,
    /* 提交确认框 */
    submitConfirm: false,
    /* 审核确认框 */
    reviewConfirm: false,
    /* 审核完成标记 */
    reviewComplete: false,
    /* 表单是否保存标记 */
    saveFlag: false,
    /* 加载标记 */
    loading: false,
    /* 车辆导入相关数据参数 */
    vehicles: [],
    importErrorDialog: {
      activate: false,
      vehicles: [],
      fails: [],
      duplicates: [],
      haveDuplicatePlate: false
    },
    IDTypeReverseMap: IDTypeReverseMap,
    IDTypeMap: IDTypeMap,
    IDTypeItems: [
      {
        text: '居民身份证',
        value: 'idCard'
      },
      {
        text: '军官证|警官证|士兵证',
        value: 'osCard'
      },
      {
        text: '护照',
        value: 'passport'
      },
      {
        text: '港澳|台湾居民来往内地通行证',
        value: 'mtPermit'
      },
      {
        text: '学生证',
        value: 'stdCard'
      }
    ],
    vehicleHeaders: [
      {text: '车辆号牌', value: 'plate', align: 'left', monospaced: '5.3em'},
      {text: '手机号码', value: 'ownerTel', align: 'right'},
      {text: '车主姓名', value: 'ownerName', align: 'right', placeholder: 'N/A'},
      {text: '所在单位', value: 'ownerOrg', align: 'right', placeholder: 'N/A'},
      {text: '证件类型', value: 'ownerIDType', align: 'right', placeholder: 'N/A', f: v => IDTypeMap[v] || ''},
      {text: '证件号码', value: 'ownerIDNumber', align: 'right', placeholder: 'N/A'},
      {text: '错误原因', value: 'error', align: 'right', placeholder: 'N/A'},
    ],
    vehicleFileProps: {
      activate: true,
      autoClose: true,
      title: '批量添加车辆'
    },
    vehicleFileRules: [
      v => !(!v || v.length === 0) || '必选',
      v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式'
    ],
    /* 上产函件预约扫描件相关参数配置 */
    pdfRules: [
      v => !(!v || v.length === 0) || '必选',
      v => !v.some(f => !/\.pdf$/i.test(f.name)) || '仅支持PDF(.pdf)格式'
    ],
    pdfProps: {
      activate: true,
      autoClose: true,
      title: '上传函件预约扫描件'
    },
    /* 通行规则配置相关使用参数 */
    setRuleDialog: {
      activate: false,
      status: 'new',
      item: {},
      index: 0,
    },
    /* 自助登记相关配置 */
    signConfig: {},
    signFlag: false,
    signUrl: ''
  }),
  computed: {
    newItem () {
      return function (module) {
        switch (module) {
          case 'basic':
            return this.basicStatus === 'new'
          case 'rule':
            return this.ruleStatus === 'new'
          case 'vehicle':
            return this.vehicleStatus === 'new'
          case 'specific':
            return this.specificStatus === 'new'
          case 'page':
            return this.pageStatus === 'new'
        }
        return true
      }
    },
    notAuth () {
      return !(this.auth instanceof Object && this.auth.name)
    },
    auth () {
      return this.$store.state.reservation.letterAuth
    }
  },
  created () {
    this.init()
  },
  watch: {
    host () {
      this.hostPhone()
    },
    'reservationForm.host.org' (val, oldVal) {
      this.host = '',
      this.reservationForm.host.hostPhone = ''
      this.reservationForm.host.hostSelect = []
    },
  },
  methods: {
    /* 组件初始化 */
    init () {
      /* 页面状态及显示初始化 */
      this.initViewStatus()
      /* 页面初始化相关文件表单信息 */
      this.initFileFormInfo()
      /* 页面初始化时查询该函件预约是否有自助登记二维码生成 */
      this.getSignCode()
      /* 初始化受访人、申请人等信息 */
      this.initUserInfo()
      /* 初始化附言等表单信息 */
      this.getSaveComment()
      this.reservationForm.passRules = []
      if (this.formData.passRuleConf.length !== 0) {
        this.reservationForm.passRules = this.formData.passRuleConf
      }
    },
    /* 页面状态及显示初始化 */
    initViewStatus () {
      let status = this.config.status
      if (status === 'review' || status === 'read') {
        this.disabledFlag = true
      }
      else {
        this.disabledFlag = false
      }
      if (this.formData.bulkImpVeList.length !== 0) {
        this.reservationForm.veSelect = 'veImport'
      }
      else if (this.formData.maxSelfReg !== '') {
        this.reservationForm.veSelect = 'veSelfSign'
      }
      else {
        this.reservationForm.veSelect = 'veImport'
      }
    },
    /* 页面初始化相关文件表单信息 */
    initFileFormInfo () {
      /* 页面初始化时查询是否有上传的PDF */
      this.findUploadPdf()
      /* 初始化表单相关信息 */
      this.reservationForm.formKey = this.config.taskConfig.relevant.form[0].formKey
      this.getFormDef()
      /* 初始化文件相关信息 */
      this.reservationForm.fileKey = this.config.taskConfig.relevant.file[0].fileKey
      this.getFileDef()
    },
    /* 查询是否有上传的PDF */
    async findUploadPdf () {
      let res = await this.$store.dispatch('letterReservation/findUploadPdf', this.config)
      if (res.data.code + '' === '200') {
        if (res.data.data != null) {
          this.downloadFlag = true
          this.saveFlag = true
          this.downloadPdfName = res.data.data.name
        }
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    /* 获取到表单数据库定义信息 */
    async getFormDef () {
      let res = await this.$store.dispatch('letterReservation/getFormDef', this.reservationForm.formKey)
      // console.log(res)
      if (res.data.code + '' === '200') {
        this.reservationForm.formDefId = res.data.data.id
        // console.log(this.reservationForm.formDefId)
      }
      else {
        this.$L.alert('error', {message: '查询表单定义ID失败，失败原因：' + res.data.msg})
      }
    },
    /* 获取到文件数据库定义信息 */
    async getFileDef () {
      let res = await this.$store.dispatch('letterReservation/getFileDef', this.reservationForm.fileKey)
      if (res.data.code + '' === '200') {
        this.reservationForm.fileDefId = res.data.data.id
      }
      else {
        this.$L.alert('error', {message: '查询文件定义ID失败，失败原因：' + res.data.msg})
      }
    },
    /* 初始化受访人、申请人等信息 */
    initUserInfo () {
      this.getOrgList()
      this.dealApplInfo()
      this.dealHostInfo(this.formData.host)
    },
    /* 处理受访人信息回显 */
    async dealHostInfo (param) {
      let res1 = await this.$store.dispatch('letterReservation/getHostGroup', {orgId: param.hostOrgId, groupId: param.hostGroupId, id: param.hostId})
      if (res1.data.status === 1) {
        // console.log(res1)
        let obj = {
          name: res1.data.data.content[0].name || '',
          value: res1.data.data.content[0].id || '',
        }
        this.reservationForm.host.org = obj
        this.reservationForm.host.orgSelect.push(obj)
        // console.log(this.activityForm.org);
      }
      let res2 = await this.$store.dispatch('letterReservation/getHostInfo', param.hostId)
      // console.log(res2)
      if (res2.data.status === 1) {
        if (res2.data.data.content.length !== 0) {
          let obj = {
            name: res2.data.data.content[0].name,
            loginId: res2.data.data.content[0].loginId,
          }
          this.reservationForm.host.hostSelect = []
          this.reservationForm.host.hostSelect.push(obj)
          // console.log(this.activityForm.intervieweeSelect);
          this.host = this.reservationForm.host.hostSelect[0]
          this.reservationForm.host.hostPhone = res2.data.data.content[0].mobilePhone
        }
      }
    },
    /* 查询受访人单位列表 */
    async getOrgList () {
      if (this.config.status !== 'edit') {
        return
      }
      let res1 = await this.$store.dispatch('letterReservation/getUserInfo', this.getUserInfo().id)
      if (res1.data.status + '' === '1') {
        //console.log(res1.data.data)
        let id = res1.data.data.content[0].id
        let res2 = await this.$store.dispatch('letterReservation/getOrgList', id)
        this.reservationForm.host.orgSelect = []
        //console.log(res2)
        for (let i = 0; i < res2.data.data.length; i++) {
          var obj = {
            name: res2.data.data[i].name,
            value: res2.data.data[i].id,
          }
          this.reservationForm.host.orgSelect.push(obj)
        }
      }
      else {
        this.$L.alert('error', {message: '查询用户信息失败'})
      }
    },
    /* 受访单位人员信息查询 */
    async hostSearch (param) {
      let value = (param === undefined) ? '' : param.target.value
      let orgId = (this.reservationForm.host.org.value === undefined) ? this.reservationForm.host.org : this.reservationForm.host.org.value
      let res = await this.$store.dispatch('letterReservation/hostSearch', {value: value, orgId: orgId})
      // console.log(res)
      if (res.data.code + '' === '200') {
        // console.log(res);
        this.reservationForm.host.hostSelect = []
        // console.log(this.reservationForm.host.hostSelect)
        for (var i = 0; i < res.data.data.length; i++) {
          var obj = {
            name: res.data.data[i].name,
            loginId: res.data.data[i].loginId,
          }
          this.reservationForm.host.hostSelect.push(obj)
        }
        console.log(this.reservationForm.host.hostSelect)
      }
    },
    /* 获取受访人员手机 */
    async hostPhone () {
      if (this.host === undefined) {
        return
      }
      let id = (this.host.loginId === undefined) ? this.host : this.host.loginId
      let res = await this.$store.dispatch('letterReservation/getApplInfo', id)
      if (res.data.status === 1) {
        // console.log(data);
        this.reservationForm.host.hostPhone = res.data.data.content[0].mobilePhone
      }
      else {
        this.$L.alert('error', {message: '查询手机失败'})
      }
    },
    /* 查询申请人信息 */
    async dealApplInfo () {
      let res = await this.$store.dispatch('letterReservation/getApplInfo', (this.formData.appl.applId === '') ? this.getUserInfo().id : this.formData.appl.applId)
      if (res.data.status === 1) {
        this.reservationForm.appl.applName = res.data.data.content[0].name
        this.reservationForm.appl.applPhone = res.data.data.content[0].mobilePhone
        console.log(res.data.data)
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    /* 查询登录用户信息 */
    getUserInfo () {
      let loginInfo = sessionStorage.getItem('loginInfo')
      loginInfo = eval('(' + loginInfo + ')')
      return loginInfo
    },
    /* 函件预约导出为PDF */
    async exportPdf () {
      /* if (!this.checkReservationInfo()) {
        return
      } */
      let saveRes = await this.saveReservation()
      if (!saveRes) {
        return
      }
      let res = await this.$store.dispatch('letterReservation/exportPdf', this.config)
      if (!res) {
      }
      else {
        debugger
        let url = window.URL.createObjectURL(res.data)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '电子科技大学机动车辆函件预约扫描件.pdf')
        document.body.appendChild(link)
        link.click()
      }
    },
    /* 上传函件预约PDF */
    async uploadPdf (files) {
      let f = files[0]
      console.log(f)
      let formData = new FormData()
      formData.append('uploadFile', f)
      formData.append('fileKey', this.reservationForm.fileKey)
      formData.append('fileDefinitionId', this.reservationForm.fileDefId)
      formData.append('taskId', this.config.taskId)
      formData.append('processId', this.config.procInstId)
      formData.append('submitedBy', this.getUserInfo().id)
      this.loading = true
      let res = await this.$store.dispatch('letterReservation/uploadPdf', formData)
      this.loading = false
      if (res.data.code + '' === '200') {
        this.downloadFlag = true
        this.downloadPdfName = res.data.data.name
        this.$L.alert('success', {message: '上传成功'})
      }
      else {
        this.$L.alert('error', {message: '上传失败，原因:' + res.data.msg})
      }
    },
    /* 下载上传的函件预约PDF */
    async downloadPdf () {
      let fileRes = await this.$store.dispatch('letterReservation/findUploadPdf', this.config)
      let fileType = ''
      if (fileRes.data.code + '' === '200') {
        fileType = fileRes.data.data.type
      }
      else {
        this.$L.alert('error', {message: '未查到文件信息,原因:'+fileRes.data.msg})
      }
      console.log(fileRes)
      let res = await this.$store.dispatch('letterReservation/downloadPdf', this.config)
      if (!res) {
        return
      }
      debugger
      let url = window.URL.createObjectURL(res.data)
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', this.downloadPdfName + '.' + fileType)
      document.body.appendChild(link)
      link.click()
    },
    /* 获取车辆信息导入模板 */
    async getExcelTemplate () {
      let url = encodeURI('https://smaco2.uestc.edu.cn/passApi/files/预约车辆批量导入模版.xlsx')
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', '预约车辆批量导入模版' + '.' + 'xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    /* 初始化导入车辆浮框 */
    resetImportDialog () {
      this.importErrorDialog = {
        activate: false,
        vehicles: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false
      }
    },
    /* 处理导入车辆信息 */
    dealVehicleList (data) {
      for (var i = 0; i < data.length; i++) {
        var obj = {
          visitorPhone: data[i]['ownerTel'],
          visitorOrg: data[i]['ownerOrg'],
          visitorName: data[i]['ownerName'],
          visitorIdNum: data[i]['ownerIDNumber'],
          visitorVeCode: data[i]['plate'],
          visitorIdType: data[i]['ownerIDType'],
        }
        this.formData.bulkImpVeList.push(obj)
      }
      this.saveReservation()
      // console.log(this.formData.bulkImpVeList)
    },
    /* 导入车辆 */
    importVehicle (vehicles) {
      if (vehicles) {
        this.vehicles.push(...vehicles)
        this.$L.alert('success', {message: `成功导入${vehicles.length}项`})
        this.dealVehicleList(this.vehicles)
      }
      this.resetImportDialog()
    },
    /* 检查车牌和电话是否合法 */
    checkVehicle (v) {
      if (!this.$reg.PLATE_PATTERN.test(v.plate)) {
        console.log('plate Check Fail')
        return 2
      }
      if (!this.$reg.PHONE_ALL.test(v.ownerTel)) {
        console.log('phone Check Fail')
        // console.log(v.ownerTel)
        return 1
      }
      if ((v.ownerIDNumber !== '' && v.ownerIDType === '') || (v.ownerIDType !== '' && v.ownerIDNumber === '')) {
        console.log(v)
        return 3
      }
      return 0
    },
    /* 读取Excel数据 */
    readExcel (files) {
      let f = files[0]
      if (!(f instanceof File)) return
      let reader = new FileReader()
      reader.onload = (event) => {
        try {
          let data = event.target.result
          let workbook = XLSX.read(data, {type: 'array'})
          let keys = Object.keys(workbook.Sheets)
          if (Object.keys(workbook.Sheets).length < 1) {
            throw Error('模板格式错误')
          }
          let sheet = workbook.Sheets[keys[0]]
          let ref = sheet['!ref']
          let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
          if (!group) {
            throw Error('模板格式错误')
          }
          let s = Number(group[1])
          let e = Number(group[2])

          if (e > this.auth.maxVehicleAmount + 1) {
            this.$L.alert('error', {
              title: '导入模板时发生错误',
              message: `给定文件条目超过最大单次预约车辆数，单次最多添加 ${this.auth.maxVehicleAmount} 辆车`
            })
            return
          }

          let atters = ['A', 'B', 'C', 'D', 'E', 'F']
          let vehicles = []
          let fails = []
          let duplicates = []
          let haveDuplicatePlate = false

          console.debug('get Excel', sheet, s, e)
          for (let i = s + 1; i <= e; ++i) {
            let plate = sheet[atters[0] + i] ? sheet[atters[0] + i].w.trim() : ''
            let phone = sheet[atters[1] + i] ? sheet[atters[1] + i].w : ''
            let org = sheet[atters[3] + i] ? sheet[atters[3] + i].w.trim() : ''
            let name = sheet[atters[2] + i] ? sheet[atters[2] + i].w.trim() : ''
            let IDNumber = sheet[atters[4] + i] ? sheet[atters[5] + i].w.trim() : ''
            let IDType = sheet[atters[5] + i] ? sheet[atters[4] + i].w.trim() : ''

            // TODO: 需要检测去除所有左右空格（空白，换行，制表等）
            // console.log('/', plate, '/', phone, '/', org, '/', name, '/', IDType, '/', IDNumber, '/')
            if (!plate && !phone && !org && !name && IDType && !IDNumber) {
              continue
            }
            // 文字转key
            if (IDType) {
              console.log(IDType, this.IDTypeReverseMap[IDType])
            }
            IDType = this.IDTypeReverseMap[IDType] || ''
            let v = new Vehicle(
              this.vehicles.length + vehicles.length,
              plate,
              phone,
              name,
              org,
              IDType,
              IDNumber
            )
            let checkRes = this.checkVehicle(v)
            if (checkRes === 0) {
              if (this.vehicles.find(t => t.plate === v.plate)) {
                duplicates.push(v)
              }
              else {
                let tmp = vehicles.find(t => t.plate === v.plate)
                if (tmp) {
                  console.log('find duplicate', tmp, v)
                  haveDuplicatePlate = true
                }
                else {
                  vehicles.push(v)
                }
              }
            }
            else {
              v.error = errorMap[checkRes]
              fails.push(v)
            }
          }
          console.log('check import', fails, duplicates, vehicles)
          if (fails.length === 0 && duplicates.length === 0 && !haveDuplicatePlate) {
            console.debug('progress successful', vehicles, fails)
            this.importVehicle(vehicles)
            // this.reservation.vehicles.push(...vehicles)
            // this.$store.commit('toggleSnackbar', {message: `成功导入${vehicles.length}项`})
          }
          else {
            this.importErrorDialog = {
              activate: true,
              vehicles: vehicles,
              fails: fails,
              duplicates: duplicates,
              haveDuplicatePlate: haveDuplicatePlate
            }
          }
        }
        catch (e) {
          console.log(e)
          this.$L.alert('error', {title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
        }
      }
      reader.readAsArrayBuffer(f)
    },
    createPassRule () {
      return new PassRule()
    },
    /* set通行规则 */
    setPassRule (res) {
      this.setRuleDialog.activate = false
      let {status, newItem, oldItem} = res
      if (status === 'new') {
        // this.reservationForm.passRules.push(newItem)
        this.formData.passRuleConf.push(newItem)
        this.setPassRuleJson(this.formData.passRuleConf)
      }
      else if (status === 'edit') {
        // this.reservationForm.passRules[this.setRuleDialog.index] = newItem
        this.formData.passRuleConf[this.setRuleDialog.index] = newItem
        this.setPassRuleJson(this.formData.passRuleConf)
      }
    },
    /* 通行规则转化为json数据 */
    setPassRuleJson (rules) {
      if (!rules.length) {
        return
      }
      let ruleDatas = []
      rules.forEach(rule => {
        let ruleData = {
          'segmentType': rule.ruleType === 'periodic' ? rule.period : '',
          'sdtime': time.toTimeStamp(rule.startDatetime).toString(),
          'edtime': time.toTimeStamp(rule.endDatetime).toString(),
          'vcbMsgIn': rule.audioPromptIn,
          'osdMsgIn': rule.ledPromptIn,
          'vcbMsgOut': rule.audioPromptOut,
          'osdMsgOut': rule.ledPromptOut,
          'config': '',
        }
        if (rule.slices && ruleData.segmentType) {
          let config = {
            period: rule.period,
            sctn_amnt: rule.slices.length,
            sctns: [],
          }
          let slices = (rule.slices || []).slice(0)
          let t = {
            'endTime': 'etime',
            'endWeekday': 'ewkday',
            'id': 'sctn_id',
            'startTime': 'stime',
            'startWeekday': 'swkday',
          }
          F.transformIO(slices, t)
          slices.forEach((slice, index) => {
            slice.controllers = gateways2controllers(slice.gateways)
            slice.sctn_id = index + ''
            slice.stime += ':00'
            slice.etime += ':00'
            delete slice.index
            delete slice.gateways
          })
          config.sctns = slices
          ruleData.config = JSON.stringify(config)
        }
        else if (!ruleData.segmentType) {
          let config = {
            controllers: gateways2controllers(rule.gateways),
          }
          ruleData.config = JSON.stringify(config)
        }
        ruleDatas.push(ruleData)
      })
      // console.log(ruleDatas)
      this.formData.passRulePara = ruleDatas
    },
    /* 删除通行规则 */
    deletePassRule (index) {
      this.formData.passRuleConf.splice(index, 1)
      this.reservationForm.passRules.splice(index, 1)
      this.formData.passRulePara.splice(index, 1)
    },
    /* 查询自助登记二维码 */
    async getSignCode () {
      let res = await this.$store.dispatch('letterReservation/getSignCode', this.config.procInstId)
      // console.log(res)
      if (res.data.code + '' === '200') {
        let data = res.data.data
        if (data != null && data.qrcodeData !== undefined) {
          // console.log(data)
          this.signConfig = eval('(' + data.qrcodeData.config + ')')
          this.signConfig.veSelfRegRule = data.veSelfRegRule
          this.signConfig.needReview = this.formData.needReview
          // console.log(this.signConfig);
          this.signFlag = true
          let picPath = data.qrcodeData.picPath
          picPath = eval('(' + picPath + ')')
          this.signUrl = '/qrcode' + picPath.midPicPath
          console.log(this.signUrl)
        }
      }
      else {
        this.$L.alert('error', {message: '查询二维码失败'})
      }
    },
    /* 保存函件预约信息 */
    async saveReservation () {
      /* 暂时写死Host相关信息 */
      this.formData.appl.applId = this.getUserInfo().id
      this.formData.host.hostId = (this.host.loginId !== undefined) ? this.host.loginId : this.host
      this.formData.host.hostOrgId = this.reservationForm.host.instId
      // console.log(this.reservationForm.host)
      this.formData.host.hostGroupId = (this.reservationForm.host.org.value === undefined) ? this.reservationForm.host.org : this.reservationForm.host.org.value
      // console.log(this.config)
      let params = {
        'taskId': this.config.taskId,
        'procInstId': this.config.procInstId,
        'formKey': this.reservationForm.formKey,
        'formValueJson': JSON.stringify(this.formData),
        'submitedBy': this.getUserInfo().id,
        'formDefId': this.reservationForm.formDefId,
      }
      this.loading = true
      let res = await this.$store.dispatch('letterReservation/saveForm', params)
      this.loading = false
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '保存成功'})
        return true
      }
      else {
        this.$L.alert('error', {message: '保存失败，原因：' + res.data.msg})
        return false
      }
    },
    /* 提交函件预约信息 */
    async submitReservation () {
      if ((this.reservationType === 'common') ? this.checkReservationInfo() : this.checkAddReservationInfo()) {
        if (this.downloadFlag === false) {
          this.$L.alert('error', {message: '该函件预约尚未上传签章预约扫描件，请上传后再进行提交保存操作'})
          return false
        }
        this.disabledFlag = true
        let saveRes = await this.saveReservation()
        if (saveRes) {
          let config = {
            'taskId': this.config.taskId,
            'procInstId': this.config.procInstId,
            'submitedBy': this.getUserInfo().id,
            'comment': this.reservationForm.comment,
          }
          this.loading = true
          this.buttonDisabled = true
          let res = await this.$store.dispatch('letterReservation/submitTask', config)
          this.loading = false
          this.buttonDisabled = false
          if (res.data.code + '' === '200') {
            this.disabledFlag = true
            this.submitConfirm = false
            this.$L.alert('success', {message: '提交成功'})
          }
          else {
            this.disabledFlag = false
            this.$L.alert('error', {message: '提交失败，原因：' + res.data.msg})
          }
        }
        else {
          this.disabledFlag = false
        }
      }
      else {

      }
    },
    /* 设置审核函件预约结果信息 */
    setReviewResult (result) {
      this.reservationForm.reviewResult = result
      this.reservationForm.reviewMsg = (result === 'refuse') ? '拒绝' : (result === 'sendBack') ? '退回' : '通过'
      this.reviewConfirm = true
    },
    async completeReviewTask (result) {
      if (result === 'refuse' || result === 'sendBack') {
        if (this.reservationForm.comment.length === 0) {
          this.$L.alert('error', {message: '附言不能为空'})
          return
        }
      }
      let variableValue = result !== 'sendBack'
      let config = {
        'taskId': this.config.taskId,
        'procInstId': this.config.procInstId,
        'reviewResult': result,
        'variableName': 'pass',
        'variableValue': variableValue,
        'formKey': this.reservationForm.formKey,
        'submitedBy': this.getUserInfo().id,
        'comment': this.reservationForm.comment,
      }
      this.loading = true
      this.buttonDisabled = true
      let res = await this.$store.dispatch('letterReservation/completeReviewTask', config)
      this.loading = false
      this.buttonDisabled = false
      if (res.data.code + '' === '200') {
        this.reviewComplete = true
        this.$L.alert('success', {message: '审核完成'})
      }
      else {
        this.$L.alert('error', {message: '提交失败，原因：' + res.data.msg})
      }
      this.reviewConfirm = false
    },
    /* 保存附言 */
    async saveComment () {
      let config = {
        'content': this.reservationForm.comment,
        'processId': this.config.procInstId,
        'taskId': this.config.taskId,
        'createdBy': this.getUserInfo().id,
      }
      let res = await this.$store.dispatch('letterReservation/saveComment', config)
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '保存附言成功'})
      }
      else {
        this.$L.alert('error', {message: '保存附言失败，原因：' + res.data.msg})
      }
    },
    /* 查询保存的附言信息 */
    async getSaveComment () {
      let res = await this.$store.dispatch('letterReservation/getSaveComment', this.config)
      if (res.data.code + '' === '200') {
        if (res.data.data !== null) {
          this.reservationForm.comment = res.data.data.content
        }
      }
      else {
        this.$L.alert('error', {message: '查询附言失败，原因：' + res.data.msg})
      }
    },
    /* 检验函件预约信息正确性 */
    checkReservationInfo () {
      if (this.$refs.reservationForm.validate()) {
        if (this.formData.passRuleConf.length === 0) {
          this.$L.alert('error', {message: '该函件预约车辆通行规则尚未配置，请进行配置后再进行保存提交操作'})
          return false
        }
        /*        if (this.reservationForm.veSelect === 'veImport') {
          if (this.formData.bulkImpVeList.length === 0) {
            this.$L.alert('error', {message: '该函件预约车辆管理类型选择的是预约车辆批量导入类型，检测到并未批量导入车辆，请进行导入后再进行保存提交操作'})
            return false
          }
        } */
        return true
      }
      else {
        this.$L.alert('error', {message: '活动相关信息存在不合法数据，请修改后再进行保存提交'})
        return false
      }
    },
    /* 检测追加的函件预约信息正确性 */
    checkAddReservationInfo () {
      if (this.formData.passRuleConf.length === 0 && this.formData.bulkImpVeList.length === 0 && this.formData.maxSelfReg === '') {
        this.$L.alert('error', {message: '追加预约必须进行追加规则或追加车辆操作'})
        return false
      }
      else if (this.downloadFlag === false) {
        this.$L.alert('error', {message: '必须进行上传扫描件操作'})
        return false
      }
      return true
    },
    /* 进入到批量导入车辆管理页面 */
    getVisitorList () {
      this.$router.push({
        name: 'visitorList',
        params: {obGrpName: ''},
        query: {id: this.config.procInstId}})
    },
    getSelfSignList () {
      this.$router.push({
        name: 'selfSignListBox',
        params: {config: this.signConfig},
        query: {id: this.config.procInstId, name: this.formData.letterApptName}
      })
    },
    async getSelfSignFile () {
      let data = await this.$store.dispatch('letterReservation/getSelfSignFile', this.config.procInstId)
      if (!data) {
        return
      }
      debugger
      let url = window.URL.createObjectURL(data.data)
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', '【自助登记使用说明】' + this.formData.letterApptName + '.' + 'pdf')
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
